export enum FirebaseEventType {
  M_INPUT = 'm_input',
  M_CLICK = 'm_click',
  M_ROUTE = 'm_route'
}
